import { render, staticRenderFns } from "./MenuEcosting.vue?vue&type=template&id=a929a3f0&scoped=true&"
import script from "./MenuEcosting.vue?vue&type=script&lang=js&"
export * from "./MenuEcosting.vue?vue&type=script&lang=js&"
import style0 from "./MenuEcosting.vue?vue&type=style&index=0&id=a929a3f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a929a3f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VDivider,VIcon,VList,VMenu})
